import React from 'react';
import AnimatedSection from '../ui/AnimatedSection';
import AnimatedCard from '../ui/AnimatedCard';

const Technologies = () => {
  const techCategories = [
    {
      category: "Frontend Technologies",
      technologies: [
        { name: "React", color: "bg-blue-500" },
        { name: "Angular", color: "bg-red-500" },
        { name: "Vue.js", color: "bg-green-500" },
        { name: "TypeScript", color: "bg-blue-600" },
        { name: "JavaScript", color: "bg-yellow-500" },
        { name: "HTML5/CSS3", color: "bg-orange-500" },
        { name: "Bootstrap", color: "bg-purple-500" },
        { name: "Tailwind CSS", color: "bg-cyan-500" }
      ]
    },
    {
      category: "Backend Technologies",
      technologies: [
        { name: "Node.js", color: "bg-green-600" },
        { name: "ASP.NET", color: "bg-blue-700" },
        { name: "C#", color: "bg-purple-600" },
        { name: "Python", color: "bg-yellow-600" },
        { name: "Java", color: "bg-red-600" },
        { name: "PHP", color: "bg-indigo-500" },
        { name: "RESTful APIs", color: "bg-teal-500" },
        { name: "GraphQL", color: "bg-pink-500" }
      ]
    },
    {
      category: "Databases",
      technologies: [
        { name: "SQL Server", color: "bg-red-700" },
        { name: "MySQL", color: "bg-blue-600" },
        { name: "PostgreSQL", color: "bg-indigo-600" },
        { name: "MongoDB", color: "bg-green-700" },
        { name: "Oracle", color: "bg-red-500" },
        { name: "Redis", color: "bg-red-600" }
      ]
    },
    {
      category: "Testing & QA",
      technologies: [
        { name: "Selenium", color: "bg-green-600" },
        { name: "Jest", color: "bg-orange-600" },
        { name: "Cypress", color: "bg-gray-700" },
        { name: "Postman", color: "bg-orange-500" },
        { name: "JMeter", color: "bg-blue-500" },
        { name: "TestNG", color: "bg-red-500" }
      ]
    },
    {
      category: "Cloud & DevOps",
      technologies: [
        { name: "AWS", color: "bg-orange-500" },
        { name: "Azure", color: "bg-blue-500" },
        { name: "Docker", color: "bg-blue-600" },
        { name: "Kubernetes", color: "bg-blue-700" },
        { name: "Jenkins", color: "bg-gray-600" },
        { name: "Git", color: "bg-red-600" },
        { name: "CI/CD", color: "bg-purple-500" }
      ]
    },
    {
      category: "Mobile Development",
      technologies: [
        { name: "React Native", color: "bg-blue-500" },
        { name: "Flutter", color: "bg-cyan-500" },
        { name: "iOS (Swift)", color: "bg-gray-800" },
        { name: "Android (Kotlin)", color: "bg-green-600" },
        { name: "Xamarin", color: "bg-blue-700" }
      ]
    }
  ];

  return (
    <section id="technologies" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-8">
            <h2 className="text-sm font-semibold text-blue-400 uppercase tracking-wider mb-2">Technologies</h2>
            <p className="text-3xl md:text-4xl font-bold text-white">Our Technology Stack</p>
          </div>
        </AnimatedSection>
        <AnimatedSection delay={0.2}>
          <p className="text-center text-gray-300 max-w-3xl mx-auto mb-12">
            We work with cutting-edge technologies and industry-standard tools to deliver robust, scalable, and future-proof solutions.
          </p>
        </AnimatedSection>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {techCategories.map((category, index) => (
            <AnimatedCard key={index} index={index}>
              <div className="dark-card rounded-xl p-6 relative z-10">
                <h3 className="text-xl font-bold mb-4 text-white">
                  {category.category}
                </h3>
                <div className="flex flex-wrap gap-2">
                  {category.technologies.map((tech, idx) => (
                    <span
                      key={idx}
                      className={`${tech.color} text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:scale-110 transition-transform duration-200 cursor-default`}
                    >
                      {tech.name}
                    </span>
                  ))}
                </div>
              </div>
            </AnimatedCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technologies;

